import { Urls } from 'config/urls';
import { getTask, postTask } from 'utils/services';
import { Input, Payment, SuccessData } from './interfaces';

export function fetchPaymentInfo(token?: string) {
  return getTask<Payment>(Urls.api.paymentInfo + (token || ''));
}

export function fetchDataRequired(paymentId: number) {
  return getTask<Input[]>(Urls.api.dataRequired + paymentId);
}

export function fetchConfirmPayment(deviceId: string, country: string, values: { [key: string]: string }) {
  return postTask<SuccessData>(Urls.api.confirmPayment, { deviceId, country, ...values });
}

export function fetchShopifyStatus(token: string) {
  return getTask<SuccessData>(`${Urls.api.shopifyStatus}${token ? `?token=${token}` : ''}`);
}

export function fetchSetCountry(country: string) {
  return postTask<{}>(Urls.api.selectCountry.replace(':country', country), {});
}
